import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 4.2rem;

  button {
    padding: 1rem 2rem;
  }
`;

export { Container };
